module.exports = __webpack_public_path__ + "img/avatar2.7a03f6ac.png";